
export const regNavn = {
    ng: {
        $rootScope: "$rootScope", //IRootScopeService
        $scope: "$scope", //IScope
        $element: "$element", //IAugmentedJQuery
        $anchorScroll: "$anchorScroll", //IAnchorScrollService
        $attrs: "$attrs", //IAttributes
        $cookies: "$cookies",
        $controller: "$controller",
        $http: "$http",
        $httpBackend: "$httpBackend",
        $httpProvider: "$httpProvider",
        $sceProvider: "$sceProvider", //ISCEProvider
        $sceDelegateProvider: "$sceDelegateProvider", //ISCEDelegateProvider
        $sce: "$sce", //ISCEService
        $window: "$window", //IWindowService
        $document: "$document",
        $resource: "$resource",
        $parse: "$parse",
        $timeout: "$timeout", //ITimeoutService
        $interval: "$interval", //IIntervalService
        $qProvider: "$qProvider",
        $q: "$q", //IQService
        $exceptionHandler: "$exceptionHandler",
        $log: "$log", //ILogService
        $injector: "$injector",
        $provide: "$provide",
        $delegate: "$delegate",
        $locationProvider: "$locationProvider",
        $location: "$location",
        $templateCache: "$templateCache",
        $cacheFactory: "$cacheFactory", //ng.ICacheFactoryService
        $animate: "$animate",
        $browser: "$browser", //merk at dette egentlig er en angularjs intern tjeneste og ikke ment for offentlig bruk
        $sanitize: "$sanitize",
        ui: {
            $state: "$state", //StateService|IStateService
            $stateProvider: "$stateProvider", //StateProvider|IStateProvider
            $urlService: "$urlService", //UrlService
            $uiRouterGlobals: '$uiRouterGlobals', //UIRouterGlobals
            $transitions: '$transitions', //TransitionService
            $transition$: '$transition$', //Transition - for bruk i StateProvider.state resolve def
            /** @deprecated */
            $urlRouterProvider: "$urlRouterProvider",
            /** @deprecated */
            $stateParams: "$stateParams" //IStateParamsService
        },

        material: {
            $mdMenu: "$mdMenu", //IMenuService
            $mdDialog: "$mdDialog", //IDialogService
            $mdToast: "$mdToast" //IToastService
        }
    },

    ngCordova: {
        $cordovaFile: "$cordovaFile", //IFileService
        $cordovaFileTransfer: "$cordovaFileTransfer",
        $cordovaFileOpener2: "$cordovaFileOpener2",
        $cordovaBadge: "$cordovaBadge",
        $cordovaKeyboard: "$cordovaKeyboard",
        $cordovaPushV5: "$cordovaPushV5",
        $cordovaGlobalization: "$cordovaGlobalization",
        $cordovaNativeStorage: "$cordovaNativeStorage"
    },

    ionic: {
        $ionicTabsDelegate: "$ionicTabsDelegate",
        $ionicConfigProvider: "$ionicConfigProvider",
        $ionicHistory: "$ionicHistory",
        $ionicActionSheet: "$ionicActionSheet",
        $ionicModal: "$ionicModal",
        $ionicPopup: "$ionicPopup",
        $ionicPopover: "$ionicPopover",
        $ionicViewSwitcher: "$ionicViewSwitcher",
        $ionicLoading: "$ionicLoading",
        $ionicNavBarDelegate: "$ionicNavBarDelegate",
        $ionicScrollDelegate: "$ionicScrollDelegate",
        $ionicGesture: "$ionicGesture",
        $ionicPlatform: "$ionicPlatform",
        $ionicPosition: "$ionicPosition"
    },


    /** tsd:angular.local.storage, https://github.com/grevory/angular-local-storage */
    storage: {
        /** angulars local storage service, som benytter nettleserens Local Storage.
         * Merk at på iOS vil data lagret her kunne bli slettet uten forvarsel dersom devicen har lite diskplass.
         * Benytt heller LokaltDatalager som på mobil er backet av et filsystem som ikke slettes ved lite diskplass. */
        localStorageService: "localStorageService",
        localStorageServiceProvider: "localStorageServiceProvider"
    },

    // ng-file-upload
    ngFileUpload: {
        Upload: "Upload" //IUploadService
    },

    //angular material
    md: {
        $mdDialog: "$mdDialog", //angular.material.IDialogService
        $mdDateLocale: "$mdDateLocale",
        $mdSidenav: "$mdSidenav",
        $mdConstant: "$mdConstant",
        $mdPanel: "$mdPanel" //angular.material.IPanelService
    }
    ,
    spin: {
        usSpinnerService: "usSpinnerService"
    },

    moment: {
        amMoment: "amMoment",
        angularMomentConfig: "angularMomentConfig",
        moment: "moment"
    },

    //lederplantjenester som ikke har noe annet sted å ha navnet sitt..
    l: {
        registrerElementKoblingerDelegat: "registrerElementKoblingerDelegat"
    },

    gettext: {
        gettextCatalog:"gettextCatalog" //gettextCatalog
    },

    smoothScroll:'smoothScroll'
};
